import { render, staticRenderFns } from "./AddCaseBatch.vue?vue&type=template&id=ba8b9f94&scoped=true"
import script from "./AddCaseBatch.vue?vue&type=script&lang=js"
export * from "./AddCaseBatch.vue?vue&type=script&lang=js"
import style0 from "./AddCaseBatch.vue?vue&type=style&index=0&id=ba8b9f94&prod&lang=css"
import style1 from "./AddCaseBatch.vue?vue&type=style&index=1&id=ba8b9f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8b9f94",
  null
  
)

export default component.exports